import Component_Physics_8e4f381551e7cd75a58dcd8e19c37041 from "../../../../content/examples/physics/Physics";
import Devtool_Physics_8e4f381551e7cd75a58dcd8e19c37041 from "!!@devtool/loader!../../../../content/examples/physics/Physics";
import Component_Physics2_8e4f381551e7cd75a58dcd8e19c37041 from "../../../../content/examples/physics/Physics2";
import Devtool_Physics2_8e4f381551e7cd75a58dcd8e19c37041 from "!!@devtool/loader!../../../../content/examples/physics/Physics2";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Physics_8e4f381551e7cd75a58dcd8e19c37041,
  Devtool_Physics_8e4f381551e7cd75a58dcd8e19c37041,
  Component_Physics2_8e4f381551e7cd75a58dcd8e19c37041,
  Devtool_Physics2_8e4f381551e7cd75a58dcd8e19c37041,
  DevTool,
  React
};